// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2nC6o","validationTips":"StatementDescriptor_validationTips__kEuqr"};